<template>
  <time v-if="formatDateHTML" class="published-date" :datetime="datetime" :data-timestamp="timestamp" itemprop="datePublished" v-html="formattedDate"></time>
  <time v-else-if="simpleDate" class="published-date" :datetime="datetime" :data-timestamp="timestamp" itemprop="datePublished">{{simpleFormattedDate}}</time>
  <time v-else class="published-date" :datetime="datetime" :data-timestamp="timestamp" itemprop="datePublished">{{formattedDate}}</time>
</template>

<script>
  import dateFormatter from 'components/mixins/dateFormatter'
  import get from 'lodash/get'
  import format from 'date-fns/format'

  export default {
    name: 'field-date',
    mixins: [dateFormatter],
    props: {
      formatDateHTML: {
        type: Boolean,
        default: false,
      },
      simpleDate: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      published() {
        return get(this, 'node.published') || get(this, 'node.created')
      },
      formattedDate() {
        return this.formatDateHTML ? this.dateFormatter(this.published, 'html') : this.dateFormatter(this.published)
      },
      simpleFormattedDate() {
        return this.dateFormatter(this.published, 'simple')
      },
      datetime() {
        return format(new Date(this.published), '(YYYY-MM-DDTHH:mm:ss.sssZ')
      },
      timestamp() {
        return new Date(this.published).getTime()
      },
    },
  }
</script>

<style lang="scss">
.published-date {
  @include respond-to("mobile") {
    text-align: center;
  }
  display: block;
  color: $oxford-blue;
  font-size: rem-calc(11);
  line-height: rem-calc(13);
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// components/node/fields/Date.vue